import React from 'react';
import { Box, ButtonBase } from '@mui/material';

/**
 * Segmentovaný prepínač — jedna dráha, aktívna položka je vyzdvihnutá plocha.
 * Nahrádza rad samostatných čipov, ktorý pri piatich obdobiach vyzeral ako päť
 * nezávislých tlačidiel namiesto jednej voľby.
 *
 * `tone="ink"` je verzia do tmavej hero karty.
 */
const SegmentedToggle = ({ value, onChange, options, tone = 'default', size = 'md', sx = {} }) => {
    const isInk = tone === 'ink';
    const height = size === 'sm' ? 30 : 34;

    return (
        <Box
            role="tablist"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.25,
                p: '3px',
                borderRadius: `${height / 2 + 3}px`,
                bgcolor: isInk ? 'rgba(255,255,255,0.08)' : 'action.hover',
                maxWidth: '100%',
                overflowX: 'auto',
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': { display: 'none' },
                ...sx,
            }}
        >
            {options.map(({ value: optionValue, label }) => {
                const active = value === optionValue;
                return (
                    <ButtonBase
                        key={String(optionValue)}
                        role="tab"
                        aria-selected={active}
                        onClick={() => onChange(optionValue)}
                        sx={(theme) => ({
                            height,
                            px: 1.75,
                            flexShrink: 0,
                            borderRadius: `${height / 2}px`,
                            fontSize: '0.8125rem',
                            fontWeight: active ? 650 : 500,
                            letterSpacing: '-0.005em',
                            whiteSpace: 'nowrap',
                            transition: 'background-color .18s ease, color .18s ease',
                            color: isInk
                                ? (active ? '#0B1524' : 'rgba(255,255,255,0.7)')
                                : (active ? theme.palette.text.primary : theme.palette.text.secondary),
                            bgcolor: isInk
                                ? (active ? '#FFFFFF' : 'transparent')
                                : (active ? theme.palette.background.paper : 'transparent'),
                            boxShadow: active && !isInk
                                ? (theme.palette.mode === 'dark'
                                    ? '0 1px 2px rgba(0,0,0,0.5)'
                                    : '0 1px 2px rgba(15,23,42,0.10)')
                                : 'none',
                            '&:focus-visible': {
                                outline: `2px solid ${isInk ? '#FFFFFF' : theme.palette.primary.main}`,
                                outlineOffset: 1,
                            },
                        })}
                    >
                        {label}
                    </ButtonBase>
                );
            })}
        </Box>
    );
};

export default SegmentedToggle;
